<template>
    <div class="user-ratings">
        <div class="user-ratings__left-side">
            <div class="user-ratings__left-side--rating">
                <div class="user-ratings__left-side--rating-top">
                    <common-rating-stars :value="averageRating" type="small"></common-rating-stars>
                    <u @click="showAllRatings">{{ $t('common.microcopy.reviews', { n: numberOfRatings }) }}</u>
                </div>

                <div>
                    <common-button
                        type="link"
                        :label="$t('components.rating.user_ratings.read_all')"
                        @click="showAllRatings"
                    ></common-button>
                </div>
            </div>

            <img width="300" :alt="$t('alt.user_rating')" :src="ratingImage" />
        </div>

        <div class="user-ratings__ratings">
            <common-content-spacer height="medium">
                <single-rating
                    v-for="i in ratings.length > 3 ? 3 : ratings.length"
                    :key="i"
                    :rating="ratings[i - 1]"
                ></single-rating>
            </common-content-spacer>
        </div>

        <all-ratings-modal v-if="showRatingsModal" :ratings="ratings" @close="hideAllRatings"></all-ratings-modal>
    </div>
</template>

<script>
    import SingleRating from 'components/page-elements/rating/SingleRating'
    import AllRatingsModal from 'components/modals/rating/AllRatingsModal'

    export default {
        components: { SingleRating, AllRatingsModal },

        props: {
            numberOfRatings: { type: Number, default: 0 },
            averageRating: { type: Number, default: 0 },
            ratings: { type: Array, default: () => new Array() },
        },
        data: () => ({
            showRatingsModal: false,
            ratingImage: require('../../../assets/images/ratings.jpg'),
        }),

        methods: {
            showAllRatings() {
                this.showRatingsModal = true
            },

            hideAllRatings() {
                this.showRatingsModal = false
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/rating/_user-rating.scss';
</style>
